import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import { DataProvider } from "@refinedev/core";
import axAPI from "../../../api/axios-instance";

type ActivityResponse = {
  active?: boolean;
  leagueId?: number;
  teamId?: number;
  teamName?: string;
  duration?: number;
  colors?: string[];
};

export const championAnimationDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    custom: async ({ url, meta }) => {
      try {
        if (url === "activity") {
          const { data } = await httpClient.get<ActivityResponse | boolean>(
            "/cms/team/animation"
          );
          return {
            data,
          };
        }

        if (url === "teams") {
          const { leagueId } = (meta || {}) as { leagueId?: number };

          if (!leagueId) {
            return { data: [] };
          }

          const { data: seasons } = await httpClient.get(
            `cms/info/allActiveSeason?leagueId=${leagueId}`
          );
          const seasonId = seasons?.[0]?.seasonId;

          if (!seasonId) {
            return { data: [] };
          }

          const { data } = await httpClient.get("cms/info/teamsBySeason", {
            params: { leagueId, seasonId },
          });

          return { data };
        }

        return Promise.reject(new Error("Неизвестный запрос"));
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    create: async ({ variables }: any) => {
      try {
        const { data } = await httpClient.post(
          "/cms/team/animation",
          variables
        );

        return { data };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
  };
